import { formatCurrency } from "@/utils/format";

interface VarianceDisplayProps {
  variance: number;
  className?: string;
}

export function VarianceDisplay({ variance, className = "" }: VarianceDisplayProps) {
  const isOverBudget = variance < 0;
  const formattedVariance = formatCurrency(Math.abs(variance));
  const statusText = isOverBudget ? " (Over)" : " (Under)";
  const statusClass = isOverBudget ? "text-destructive" : "text-green-600";

  return (
    <span className={`${statusClass} font-medium ${className}`} aria-label={`Variance: ${formattedVariance} ${statusText}`}>
      {formattedVariance}
      {statusText}
    </span>
  );
}
